import React from "react";
import { FormattedMessage, injectIntl, defineMessages } from "react-intl";
import { IconArrowRight, IconBack, IconClose } from "../../../icons/svg";
import { ERROR_CODE, HIDE_TOPIC_ACTION } from '../../../tinode/constants'
import { Tinode } from '../../../tinode/tinode'
import Helpers from "../../../lib/helpers";
import HashNavigation from '../../../lib/navigation.js'
import { profile } from "../../../stores/storages/ProfileStorage";

const messages = defineMessages({
	dialog_hide_topic_title: {
		id: "dialog_hide_topic_title",
		defaultMessage: "Hide conversation",
		description: "Hide conversation",
	},
	dialog_unhide_topic_title: {
		id: "dialog_unhide_topic_title",
		defaultMessage: "Unhide conversation",
		description: "Unhide conversation",
	},
	dialog_set_pin_hide_topic_title: {
		id: "dialog_set_pin_hide_topic_title",
		defaultMessage: "Enter your new PIN",
		description: "Set new pin hide conversation",
	},
	reset_hide_password_desc: {
		id: "reset_hide_password_desc",
		defaultMessage: "Enter your PIN to continue. If forgotten, please ",
		description: "Reset hide conversations password describe",
	},
	reset_hide_password: {
		id: "reset_hide_password",
		defaultMessage: "Reset PIN",
		description: "Reset hide conversations password button",
	},
	hide_topic_success: {
		id: "hide_topic_success",
		defaultMessage: "Conversation {name} is now hidden",
		description: "Notify hide topic success",
	},
	unhide_topic_success: {
		id: "unhide_topic_success",
		defaultMessage: "Conversation {name} is now unhidden",
		description: "Notify unhide topic success",
	},
	hide_topic_fail: {
		id: "notify_error",
		defaultMessage: "An error occurred. Please try again later",
		description: "Notify error",
	},
	hide_topic_wrong_pin: {
		id: "hide_topic_wrong_pin",
		defaultMessage: "The PIN is incorrect",
		description: "The PIN is incorrect",
	},
	reset_hide_password_warning: {
		id: "reset_hide_password_warning",
		defaultMessage: "Resetting your PIN will remove old PIN and all settings. Also, ALL your current hidden conversations will be DELETED.",
		description: "Reset hide password warning",
	},
	reset_password_success: {
		id: "reset_password_success",
		defaultMessage: "Reset PIN successfully",
		description: "Reset PIN successfully",
	},
	enter_new_pin_desc: {
		id: "enter_new_pin_desc",
		defaultMessage: "Remember your PIN. All hidden conversations will be lost if you forget the code.",
		description: "Remember your PIN. All hidden conversations will be lost if you forget the code.",
	},
	enter_new_pin_confirm: {
		id: "enter_new_pin_confirm",
		defaultMessage: "Re-enter your PIN",
		description: "Re-enter your PIN",
	},
	enter_new_pin_confirm_error: {
		id: "enter_new_pin_confirm_error",
		defaultMessage: "PIN code does not match, please check again.",
		description: "PIN code does not match, please check again.",
	},
	set_password_success: {
		id: "set_password_success",
		defaultMessage: "PIN code does not match, please check again.",
		description: "PIN code does not match, please check again.",
	}
})

class HideConversation extends React.Component {
	constructor(props) {
		super(props);

		this.handleChangeHidePassword = this.handleChangeHidePassword.bind(this)
		this.handleResetHidePassword = this.handleResetHidePassword.bind(this)
		this.onResetPassword = this.onResetPassword.bind(this)
	}

	handleChangeHidePassword() {
		let action = HIDE_TOPIC_ACTION.CHANGE_PASSWORD
		if (!profile.settings || !profile.settings.hide_thread.pin) {
			action = HIDE_TOPIC_ACTION.SET_NEW_PASSWORD
		}
		const data = {
			action,
		}

		this.props.onShowDialog(Tinode.DIALOG_TYPE.HIDE_TOPIC, data)
	}

	handleResetHidePassword() {
		const { formatMessage } = this.props.intl;
		this.props.onShowAlert(
			formatMessage(messages.reset_hide_password), // title
			formatMessage(messages.reset_hide_password_warning), // content
			(_) => this.onResetPassword(), // onConfirm
			null, // "OK"
			true, // Show Reject button
			null // "Cancel"
		);
	}

	onResetPassword() {
		this.props.tinode.resetHidePassword().then((res) => {
			const { formatMessage } = this.props.intl;
			if (res.errorCode === ERROR_CODE.SUCCESS) {
				Helpers.showSuccessToasts(formatMessage(messages.reset_password_success))
				this.props.onClose()
				this.props.onSearchContacts(Tinode.DEL_CHAR)
				HashNavigation.navigateTo('');
			} else {
				Helpers.showErrorToasts(formatMessage(messages.hide_topic_fail))
			}

		})
	}

	render() {
		return (
			<React.Fragment>
				<div className="header">
					<div className="title dialog-flex-center">
						<div className="icon mr-4" onClick={this.props.handleShowSettingHome}>
							<IconBack />
						</div>
						<FormattedMessage id="dialog_hide_topic" defaultMessage={"Hidden conversations"} />
					</div>
					<div className="icon" onClick={this.props.onClose}><IconClose /></div>
				</div>
				<div className="border-content-setting" onClick={this.handleChangeHidePassword}>
					<div className="gr-setting">
						<div className="name">
							<FormattedMessage id="dialog_change_pin" defaultMessage={"Change PIN"} />
						</div>
						<div className="icon">
							<IconArrowRight />
						</div>
					</div>
				</div>
				<div className="border-content-setting" onClick={this.handleResetHidePassword}>
					<div className="gr-setting">
						<div className="name">
							<FormattedMessage id="dialog_reset_pin" defaultMessage={"Reset Pin"} />
						</div>
						<div className="icon">
							<IconArrowRight />
						</div>
					</div>
				</div>
			</React.Fragment>
		)
	}
}

export default injectIntl(HideConversation)